import { useMemo } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { RecoveryManagementScreens } from '../components/RecoveryManagementScreens'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'

interface LocationState {
    objectID?: string
    objectDescription?: string | null
    forecastStartTime?: string | Date | null
    from?: string
    readOnly?: boolean
}

export function RecoveryRunbookPage() {
    const { t } = useTranslation()
    const { requestId } = useParams<{ requestId: string }>()
    const navigate = useNavigate()
    const location = useLocation()
    const state = location.state as LocationState | null
    const objectID = state?.objectID || ''
    const objectDescription = state?.objectDescription ?? null
    const backTo = state?.from || '/update-runbook'
    const forecastStartTimeRaw = state?.forecastStartTime

    const requestID = requestId?.trim() ?? ''
    const isValidRequest = requestID.length > 0

    const forecastStartTime: Date | null = useMemo(() => {
        if (!forecastStartTimeRaw) return new Date()
        if (forecastStartTimeRaw instanceof Date) return forecastStartTimeRaw
        if (typeof forecastStartTimeRaw === 'string') {
            const d = new Date(forecastStartTimeRaw)
            return isNaN(d.getTime()) ? new Date() : d
        }
        return new Date()
    }, [forecastStartTimeRaw])

    if (!isValidRequest) {
        return (
            <div className="space-y-4" style={{ padding: 'var(--spacing-page)' }}>
                <p className="text-muted-foreground">{t('recoverRequests.errorLoading') || 'Invalid request'}</p>
                <Button variant="outline" onClick={() => navigate(backTo)}>
                    <ArrowLeft className="h-4 w-4 mr-2" />
                    {t('common.back')}
                </Button>
            </div>
        )
    }

    return (
        <RecoveryManagementScreens
            requestID={requestID}
            objectID={objectID || undefined}
            objectDescription={objectDescription}
            forecastStartTime={forecastStartTime}
            title={state?.readOnly === true ? t('recoverRequests.viewRecoveryRunbook', 'View Recovery Runbook') : t('recoverRequests.runbookUpdate', 'Runbook Update')}
            showBackButton
            onBack={() => navigate(backTo)}
            readOnly={state?.readOnly === true}
        />
    )
}
